import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
// create an axios instance
const path = require('path')
const service = axios.create({
    baseURL: window.SITE_CONFIG.Url,
    headers: { 'X-Requested-With': 'XMLHttpRequest', 'tenant-id': '1' },
    timeout: 60000 // request timeout
})
service.interceptors.request.use(config => {
        // 是否需要设置 token
        // const isToken = (config.headers || {}).isToken === false
        var token = localStorage.getItem('token') || {}
        console.log(token)
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token // 让每个请求携带自定义token 请根据实际情况自行修改
        }
        // 设置租户
        // if (getTenantEnable()) {
        //     const tenantId = getTenantId();
        //     if (tenantId) {
        //         config.headers['tenant-id'] = tenantId;
        //     }
        // }

        return config
    }, error => {
        console.log(error)
        Promise.reject(error)
    })
    // request interceptor

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const res = response
        console.log(response)
        if (res.data.code == 401) {
            localStorage.removeItem('userInfo')
            localStorage.removeItem('token')
            localStorage.removeItem('refreshToken')
        }
        return res.data
    },
    error => {
        // console.log(error.response) // for debug
        if (error.response.data.status === "C002") {
            store.dispatch('user/resetToken').then(() => {
                location.reload()
            })
        }
        Message({
            message: error.response.data.message,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)

export default service


// WEBPACK FOOTER //
// ./src/utils/request.js